import { render, staticRenderFns } from "./u-file-input-solo-pill.vue?vue&type=template&id=2976e516&scoped=true"
import script from "./u-file-input-solo-pill.vue?vue&type=script&lang=js"
export * from "./u-file-input-solo-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2976e516",
  null
  
)

export default component.exports